import styled from 'styled-components'

import { Colors } from '@fourthwall/components'

export const Subheading = styled.div`
  margin-top: 8px;
  color: ${Colors.GS600};
`
